import React from 'react';
import { CircularProgress } from '@mui/material';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CustomButton from '../../../../../components/buttons/CustomButton';
import RoomRow from './RoomRow';
import RoomListSkeleton from './RoomListSkeleton';
import styles from './RoomListCard.module.css';

const countLabel = (count, singular, plural) => `${count} ${count === 1 ? singular : plural}`;

/** Estado vazio: para que serve a sala e, para quem pode editar, o atalho da primeira. */
function EmptyRooms({ canEdit, onAdd }) {
    return (
        <div className={styles.empty}>
            <span className={styles.emptyArt} aria-hidden="true">
                <span className={styles.emptyArtBack} />
                <span className={styles.emptyArtIcon}><MeetingRoomOutlinedIcon /></span>
            </span>
            <span className={styles.emptyTitle}>Nenhuma sala cadastrada</span>
            <span className={styles.emptyText}>
                Cadastre as salas para indicar onde cada atendimento acontece.
            </span>
            {canEdit && (
                <CustomButton
                    style="main"
                    variant="contained"
                    icon={<AddRoundedIcon />}
                    label="Criar primeira sala"
                    onClick={onAdd}
                />
            )}
        </div>
    );
}

/** Lista das salas: título com o total, contagem de ativas e inativas, carregamento, estado vazio e uma linha por sala. */
function RoomListCard({ loading, rooms, occupancyData, canEdit, busy, reactivateHint, onAdd, onEdit, onToggle, onDelete }) {
    const activeCount = rooms.filter((room) => room.is_active).length;
    const inactiveCount = rooms.length - activeCount;

    return (
        <section className={styles.card}>
            <header className={styles.header}>
                <div className={styles.headerText}>
                    <h3 className={styles.title}>
                        Salas cadastradas{!loading && rooms.length > 0 ? ` · ${rooms.length}` : ''}
                    </h3>
                    {rooms.length > 0 && (
                        <span className={styles.subtitle}>
                            {countLabel(activeCount, 'ativa', 'ativas')}
                            {inactiveCount > 0 ? ` · ${countLabel(inactiveCount, 'inativa', 'inativas')}` : ''}
                        </span>
                    )}
                </div>
                {busy && (
                    <span className={styles.busy}>
                        <CircularProgress size={14} />
                        Processando...
                    </span>
                )}
            </header>

            {loading ? (
                <RoomListSkeleton />
            ) : rooms.length === 0 ? (
                <EmptyRooms canEdit={canEdit} onAdd={onAdd} />
            ) : (
                <ul className={styles.list}>
                    {rooms.map((room) => (
                        <RoomRow
                            key={room.id}
                            room={room}
                            occupancy={occupancyData[room.id]}
                            canEdit={canEdit}
                            busy={busy}
                            reactivateHint={reactivateHint}
                            onEdit={onEdit}
                            onToggle={onToggle}
                            onDelete={onDelete}
                        />
                    ))}
                </ul>
            )}
        </section>
    );
}

export default RoomListCard;
